<template>
    <layout-basic>
        <v-container>
            <section class="container-new banner-text">
                <v-row align="center" justify="center">
                    <v-col cols="12" md="6">
                        <img class="w-100 blog-banner-img" src="/static/pages/blog/business-case-for-outsourced-hr-partners-becoming-complete-business-partners.jpg" alt="the-business-case-for-outsourced-hr-partners" />
                    </v-col>
                    <v-col cols="12" md="6" class="p-0">
                        <div class="blog-banner-content">
                            <a href="/blog/the-business-case-for-outsourced-hr-partners">
                                <h1 class="font-sora">The Business Case for Outsourced HR partners becoming complete business partners</h1>
                            </a>
                            <p class="blog-banner-date fs-18"><img class="d-inline" src="/static/pages/blog/clock.png" /> 4 min read</p>
                        </div>
                    </v-col>
                </v-row>
            </section>

            <!-- filter section -->
            <section class="container-new" style="margin-top: 30px;">
                <v-row align="center" justify="center" style="gap: 1em;">                    
                    <v-btn class="filter-btn" @click="AllBlogs = true, NewsBlogs = false, UpdatesBlogs = false">All</v-btn>
                    <v-btn class="filter-btn" @click="AllBlogs = false, NewsBlogs = true, UpdatesBlogs = false">News</v-btn>
                    <v-btn class="filter-btn" @click="AllBlogs = false, NewsBlogs = false, UpdatesBlogs = true">Updates</v-btn>
                </v-row>
            </section>
            <section class="container-new" style="margin-top: 30px;">
                <v-row>
                    <v-col cols="12" sm="6" md="4" lg="3" v-if="AllBlogs || NewsBlogs">
                        <div class="course-item blog-item">
                            <img class="w-100 d-block" src="/static/pages/single-blogs/the-birth-of-mobile-phone-learning-for-smes.jpg" alt="Mobile Phone Learning for SMEs" />
                            <div class="description">
                                <p class="fs-20 black--text">The Birth of Mobile Phone Learning for SMEs?</p>
                                <p class="black--text">It is rare nowadays to not have a SMART phone, we seem to spend most of our lives on the phone and use it as a major source of learning whether we realise it or not.</p>
                                <v-btn href="/blog/birth-of-mobile-phone-learning" color="primary" style="margin: 0;" class="blue-button">Learn More</v-btn>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3" v-if="AllBlogs || UpdatesBlogs">
                        <div class="course-item blog-item">
                            <img class="w-100 d-block" src="/static/pages/single-blogs/why-learning-and-development-is-vital-to-sme-business-growth.jpg" alt="Learning & Development" />
                            <div class="description">
                                <p class="fs-20 black--text">Why Learning & Development is Vital to SME Business Growth?</p>
                                <p class="black--text">Learning & Development is no longer a nice-to-have, it is central to any business’s development and growth plans.</p>
                                <v-btn href="/blog/learning-and-development-vital-sme-business-growth" color="primary" style="margin: 0;" class="blue-button">Learn More</v-btn>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3" v-if="AllBlogs || UpdatesBlogs">
                        <div class="course-item blog-item">
                            <img class="w-100 d-block" src="/static/pages/single-blogs/smes-outsourcing-their-hr-company.jpg" alt='Outsource Learning & Development' />
                            <div class="description">
                                <p class="fs-20 black--text">Why Successful SMEs Outsource their Learning & Development</p>
                                <p class="black--text">Learning & Development is no longer a nice-to-have, it is central to any business’s development and growth plans.</p>
                                <v-btn href="/blog/sme-outsource-learning-and-development" color="primary" style="margin: 0;" class="blue-button">Learn More</v-btn>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3" v-if="AllBlogs || NewsBlogs">
                        <div class="course-item blog-item">
                            <img class="w-100 d-block" src="/static/pages/single-blogs/how-in-an-ever-changing-world-smes-can-succeed-through-outsourcing.jpg" alt="Outsourced HR partners" />
                            <div class="description">
                                <p class="fs-20 black--text">When should an Outsourcing HR Company add L&D to its portfolio?</p>
                                <p class="black--text">Every Small business needs to keep on top of its legal duties and overstretched owners have come to rely upon Outsourced HR partners to carry the heavy load of keeping them legal and compliant.</p>
                                <v-btn href="/blog/when-should-an-outsourcing-hr-company-add-ld-to-its-portfolio" color="primary" style="margin: 0;" class="blue-button">Learn More</v-btn>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3" v-if="AllBlogs || NewsBlogs">
                        <div class="course-item blog-item">
                            <img class="w-100 d-block" src="/static/pages/single-blogs/the-benefits-for-smes-in-developing-your-people.jpg" alt="Benefits for SMEs in Developing your people" />
                            <div class="description">
                                <p class="fs-20 black--text">The Benefits for SMEs in Developing your people</p>
                                <p class="black--text">Investing in people is always a challenge particularly for SME’s. The old adage on social media is what happens if we train people and they leave?</p>
                                <v-btn href="/blog/what-are-the-benefits-for-smes-in-developing-their-people" color="primary" style="margin: 0;" class="blue-button">Learn More</v-btn>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4" lg="3" v-if="AllBlogs || NewsBlogs">
                        <div class="course-item blog-item">
                            <img class="w-100 d-block" src="/static/pages/single-blogs/why-successful-smes-outsource-their-learning-and-development.jpg" alt="SME businesses" />
                            <div class="description">
                                <p class="fs-20 black--text">How in an ever-changing world SMEs can succeed through outsourcing.</p>
                                <p class="black--text">There was as a time before the internet, before smart phones before mobile working. In those days if you wanted to look things up you researched the encyclopaedia.</p>
                                <v-btn href="/blog/how-in-an-ever-changing-world-sme-companies-can-succeed-through-outsourcing" color="primary" style="margin: 0;" class="blue-button">Learn More</v-btn>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </section>
            <!-- <v-row>
                <v-col cols="12" md="12">
                    <div class="text-center mb-50">
                        <v-btn href="#" class="green-button">Load More</v-btn>
                    </div>
                </v-col>
            </v-row> -->
        </v-container>
    </layout-basic>
</template>

<script>
    import LayoutBasic from "@/layouts/Dashboard";
    export default {
        name: "Blog",
        data() {
            return {
                AllBlogs: true,
                NewsBlogs: false,
                UpdatesBlogs: false,
            }
        },
        metaInfo() {
            return { 
                title: "IMPROVE Blog: Latest Updates on Online Learning & SME Development",
                meta: [
                    // Meta Description
                    { name: 'description', content: "Stay informed with the latest updates on IMPROVE, the UK's leading online microlearning platform. Discover SME training resources, learning solutions, and expert insights." },
                    
                    // Keywords
                    { name: 'keywords', content: "IMPROVE blog, SME updates, online learning news, SME training, learning and development, small business education, microlearning solutions" },
                    
                    // Open Graph / Facebook Tags
                    { property: 'og:title', content: "IMPROVE Blog: Latest Updates on Online Learning & SME Development" },
                    { property: 'og:description', content: "Stay informed with the latest updates on IMPROVE, the UK's leading online microlearning platform. Discover SME training resources, learning solutions, and expert insights." },
                    { property: 'og:image', content: 'https://www.improve.online/static/seo.png' },
                    { property: 'og:type', content: 'website' },
                    { property: 'og:url', content: 'https://www.improve.online/blog' },

                    // Twitter Card Tags
                    { name: 'twitter:card', content: 'summary_large_image' },
                    { name: 'twitter:title', content: "IMPROVE Blog: Latest Updates on Online Learning & SME Development" },
                    { name: 'twitter:description', content: "Stay informed with the latest updates on IMPROVE, the UK's leading online microlearning platform. Discover SME training resources, learning solutions, and expert insights." },
                    { name: 'twitter:image', content: 'https://www.improve.online/static/seo.png' }
                ],
                link: [
                    // Canonical URL
                    { rel: 'canonical', href: 'https://www.improve.online/blog' }
                ]
            }
        },
        components: {
            LayoutBasic
        }
    };
</script>

<style scoped>
    .v-btn.blue-button {
        height: unset !important;
    }

    .description {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .filter-btn{
        background-color: #162b44 !important;
        color: #fff !important;
    }

    .filter-btn.active-filter {
        background-color: #204060 !important; /* Lighter shade of #162b44 */
    }
</style>
